<template>
  
  <div class="container">
  
    <Cabecera></Cabecera>
    <b-breadcrumb>
    <b-breadcrumb-item href="#"><router-link to="/">Inicio</router-link></b-breadcrumb-item>
    <b-breadcrumb-item href="#"><router-link to="/menuinicial">Inicio Usuario </router-link></b-breadcrumb-item>
    <b-breadcrumb-item href="#"><router-link to="/QRPesos">Generar QR de pesos</router-link></b-breadcrumb-item>
    
  </b-breadcrumb>
  <div>
  <Menu/>
    
  <b-card>
    
   <br>

        
          <span class="card-title">Consulta de pesos de canales (Bovinos)</span>
          <form id="formPeso" autocomplete="off" enctype="multipart/form-data">
            <input type="text" placeholder="Unidad" :value=unidad required disabled>
             <input type="date" name="fecharegistro" id="fecharegistro" placeholder="Fecha" v-on:click=usuario() v-model=fechaconsulta required>
              <input type="text" name="iniciales" id="iniciales" placeholder="Iniciales" v-model=inicialesForma required>
             
             
             <input type="hidden" name="usuarioForma" id="usuarioForma" :value=usuariolocal>
             <input type="hidden" name="idForma" id="idForma" :value=idActual>
             <input type="hidden" name="unidadForma" id="unidadForma" :value=unidad>
             <input type="hidden" name="fotoForma" id="fotoForma" :value=fotoActual>

           
<div class="card-action">
                        <h6 style="color:Tomato;font-weight:bold;">{{corregir}}</h6>
                         <b-button variant="primary" v-on:click=ajax() :class="boton">Generar</b-button><br>
                         
                         <qrcode-vue class='codigoQR' :value=mensaje2 :size="size" level="H" renderAs='canvas' background='#ffffff' foreground='#000000'></qrcode-vue>
                         <br>
                         {{mensaje3}}
    
                           
        </div>
            </form>
       

    <b-card-body class="text-center">
     

      <b-card-text>
       <div v-if="1==0">
    <h5>Listado del día <input width="4" type="date" name="fechadia" id="fechadia" placeholder="Fecha" v-on:click=ajaxdelay() >
<p id="datetime"></p>
    </h5>
   <vue-good-table
   :columns="columns"
     :rows="rows"
     @on-cell-click="onCellClick"
     
     :pagination-options="{
       enabled:true,
      
       mode:'remote',
       perPage:350,
       position:'top',
       perPageDropdown:[10,50,100],
       nextLabel:'Siguiente',
       PrevLabel:'Anterior',
       rowsPerPageLabel:'Filas por página',
       ofLabel:'de'
     }"
     :search-options="{
       enabled:true,
       trigger:'enter',
       placeholder:'Buscar'
     }"
   >
     <template slot="table-row" slot-scope="props">
          
    <span v-if="props.column.field == 'eliminar'">
       
       <b-button variant='danger'>Eliminar</b-button>
     
    </span>
    <span v-else>
      {{props.formattedRow[props.column.field]}}
    </span>
  </template>
   </vue-good-table>
</div>
      </b-card-text>

      
    </b-card-body>
  </b-card>
</div>

    
  </div>
</template>

<script>
import Cabecera from './Cabecera' //v-on:keyup.enter="onEnter"
import Menu from './Menu'
import axios from 'axios'
import swal from 'sweetalert'
import sesion from '../mixins/sesion'
import QrcodeVue from 'qrcode.vue'

import qrCode from 'qrcode'
import jsPDF from 'jspdf'
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from 'vue-qrcode-reader'

import eliminarPesosBovinos from '../mixins/eliminarPesosBovinos'
import {mapState, mapMutations, mapActions, mapGetters} from 'vuex'
export default {
  name: 'QRPesos',  
  data () {
    return {
        value:1,
         boton:'btn blue',
      msg: 'Número de arete',
      usuariolocal:'',
      fotolocal:'',
      unidad:'',
        fecha1:'',
        fecha2:'',
        corregir:'',
        canal:'',
        serie:'',
        texto:'',
        mensaje2:'hola',
        mensaje3:'',
        size:300,
        fechaconsulta:'',
        inicialesForma:'',
      columns:[
        {
          label:'Folio',
          field:'canal'
        },
        {
          label:'Fecha',
          field:'fecha',
          type:'date',
          dateInputFormat:'yyyy-mm-dd',
          dateOutputFormat:'yyyy-mm-dd'
        },
        {
          label:'Peso',
          field:'peso'
        },
        {
          label:'Eliminar',
          field:'eliminar'
        },
      ],
      rows:[

      ]
    }
  },
  computed:{
     ...mapState(['usuarioActual','idActual','fotoActual'])
  },
  methods:{
    validarCanal(){
            
                const formData = new FormData()
                formData.append('serie',this.serie)
                formData.append('unidadForma',this.unidad)
                formData.append('canal',this.value)
               /* EN caso de querer mandar más de un dato se repite varias veces y se cambia el nombre y la variable
                FormData.append('correo',this.correo)
                FormData.append('correo',this.correo)*/
                //axios.post('httpss://proyectocdnywebpack.000webhostapp.com/snippetWebpack/api/loginRegistro/validarEmail.php',formData)
                axios.post('https://micomidasegura.mx/comidaSegura/api/crud/validarCanal.php',formData)
                    .then(res=>{
                        this.respuesta = res.data
                        if (res.data =='success') {
                            this.boton = 'btn blue'
                            this.corregir=''
                        } else {
                            this.boton = 'btn blue disabled'
                            this.corregir='El canal indicado ya está registrado'
                            swal({
                    title:'El canal indicado ya está registrado',
                    icon: 'error'}) 
                        }
                    })
    },
    getId(){
           this.usuario()

            const id = document.getElementById("usuarioForma").value
            
            axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getPerfilUsuario.php?id='+ id)
            
                .then(response=>{
                   
                    this.unidad = response.data.unidad
                  
                    
                })
                   
        },

     onCellClick(params) {
         if(params.column.field=="eliminar"){
         this.eliminarPesosBovinos(params.row.id)
         this.ajax()
         }
        this.ajax()
         //
   // alert (params.row.id) // params.row - row object   /// 
    // params.pageIndex - index of this row on the current page.
    // params.selected - if selection is enabled this argument 
    // indicates selected or not
    // params.event - click event
  },
      /*onEnter: function() {
      swal("Mensaje de enter")
    },*/
    fecha(){
        var dt = new Date();
    document.getElementById("datetime").innerHTML = ((dt.getFullYear() +"-"+ (("0"+(dt.getMonth()+1)).slice(-2)) 
    +"-"+ ("0"+dt.getDate()).slice(-2)));
    },
    ajaxdelay(){
     setTimeout(() => {  this.ajax(); }, 2500)
    },
    ajax(){
      //this.getId()
     //const fecha = JSON.parse(document.getElementsByName('fecharegistro').value)
     const fecha = this.fechaconsulta
     const unidadquery=this.unidad
     const inicialesquery=this.inicialesForma
      axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getBovinosPesosReporte.php?fecha='+fecha+'&unidad='+unidadquery+'&iniciales='+inicialesquery)
      .then(response=>{
        this.rows=response.data
        this.texto=this.rows
        this.mensaje2=JSON.stringify(this.texto); 
       this.mensaje3=this.mensaje2
        this.mensaje3=this.mensaje3.replace(/},{/g, "\r\n")
        this.mensaje3=this.mensaje3.replace(/"/g, '')
        
        this.mensaje2=this.mensaje2.replace(/.000/g,'')
        this.mensaje2=this.mensaje2.replace(/"/g,'')
        //this.mensaje2=this.mensaje2.replace(/,/g,'')
        this.mensaje2=this.mensaje2.replace(/{/g,'')
        this.mensaje2=this.mensaje2.replace(/}/g,'')
        this.mensaje2=this.mensaje2.replace(/:/g,'')
        this.mensaje2=this.mensaje2.replace(/C/g,'')
        
        
      })

    },
    usuario(){
       // this.fecha()
     //const fecha = JSON.parse(document.getElementsByName('fecharegistro').value)
     var yourString = this.$localStorage.get('token');
     var result = yourString.slice(1,-1);
     this.usuariolocal= result
     const tok=this.usuariolocal
      axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getUserData2.php?token='+tok)
      .then(response=>{
       
        this.usuariolocal=response.data.email
        this.unidad=response.data.unidad
        this.perfil=response.data.perfil
      })

    },
    ticketIncremento(){
       // document.getElementById('canal').value=document.getElementById('canal').value++
    this.value=Number(this.value)+1
    this.validarCanal()
    },
    editar(){
      if(this.boton == 'btn blue disabled'){

            }
            else{
            //this.usuario()
             const form=document.getElementById('formPeso')
                axios.post('https://micomidasegura.mx/comidaSegura/api/crud/registrarPeso.php',new FormData(form))
                .then(res=>{
                    this.respuesta = res.data
                    if (res.data == 'success') {
                       this.ajax()
                    this.ticketIncremento()
                        document.getElementById("peso").value=""
                      document.getElementById("peso").focus()
                       //swal('El registro fue editado')
                        //this.$router.push('/inicio')
                        
                    } else {
                        swal('El registro no pudo ser editado'+res.data)
                    }
                })
            }
        },
        direccionamiento(){
            if (this.respuesta=='success') {
                this.$router.push('/')
            } else {
                swal({
                    title:'No se pudo registrar',
                    icon: 'error'})  
            }
        },
  },
  created(){
    //this.ajax()
    this.usuario()
  },
  components:{
    Cabecera,
    Menu,
     QrcodeVue,
     QrcodeStream, 
    QrcodeDropZone, 
    QrcodeCapture 
  },
  mixins:[sesion,eliminarPesosBovinos]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/QRPesos.vue